export const alert = {
  namespaced: true,
  state: {
    type: null,
    message: null,
  },
  actions: {
    success({ commit }, message) {
      commit("SUCCESS", message);
    },
    error({ commit, dispatch }, message) {
      commit("ERROR", message);
      setTimeout(() => dispatch("clear"), 5000);
    },
    clear({ commit }) {
      commit("CLEAR");
    },
  },
  mutations: {
    SUCCESS(state, message) {
      state.type = "alert-success";
      state.message = message;
    },
    ERROR(state, message) {
      state.type = "alert-danger";
      state.message = message;
    },
    CLEAR(state) {
      state.type = null;
      state.message = null;
    },
  },
};
